import { createApp } from 'vue'
import App from './App.vue'

import store from './store'
import vuetify from './plugins/vuetify'
import head from './plugins/vue-head'

import './assets/scss/theme.scss'
import './assets/css/vendor-custom.css'

export default (async () => {
  if (store.state.microsite.meta === null) {
    await store.dispatch('microsite/getMeta')
  }

  const router = (await import('./router')).default

  const app = createApp(App)
  app.use(store)
  app.use(router)
  app.use(vuetify)
  app.use(head)
  app.mount('#app')

  return app
})()
